import script from "./FileDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDownload.vue?vue&type=script&setup=true&lang=js"

import "./FileDownload.vue?vue&type=style&index=0&id=3f8a38fd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8a38fd"]])

export default __exports__